"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YbxError = void 0;
var tslib_1 = require("tslib");
var YbxError = (function (_super) {
    (0, tslib_1.__extends)(YbxError, _super);
    function YbxError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.isYbxError = true;
        _this.responseError = msg;
        _this.turretRunResponse = {
            xdr: '',
            signer: '',
            signature: '',
            cost: '',
            feeSponsor: '',
            feeBalanceRemaining: '',
            error: '',
        };
        return _this;
    }
    return YbxError;
}(Error));
exports.YbxError = YbxError;
//# sourceMappingURL=YbxError.js.map